import BaseApiService from "./BaseApi.service";

class AxiosService extends BaseApiService {}

export default new AxiosService();
